import { api } from './client'

// Bảng giá Online: giá gồm VAT (đồng, số nguyên) bán trên website. SKU chưa có
// giá Online bán theo giá ERP + VAT. Tách hẳn khỏi giá sản phẩm ERP.

export type OnlinePriceSource = 'online_price_list' | 'erp_unit_price'

export interface OnlinePriceItem {
    product_id: string
    sku: string
    name: string
    unit: string
    /** Giá ERP chưa VAT (products.unit_price). */
    unit_price: number
    /** Giá web khi không có giá Online: giá ERP + VAT, làm tròn đồng. */
    erp_price_incl_vat: number
    /** Giá Online đang đặt; null = chưa đặt. */
    online_price: number | null
    /** Giá website đang bán (đúng số catalog trả cho web). */
    price_incl_vat: number
    price_source: OnlinePriceSource
    updated_at: string | null
    updated_by_name: string | null
}

export interface OnlinePriceList {
    vat_percent: number
    items: OnlinePriceItem[]
}

/** Giá Online tối đa server nhận (đồng). */
export const MAX_ONLINE_PRICE = 1_000_000_000

export const onlinePriceApi = {
    list: () => api.get<OnlinePriceList>('/online-prices'),
    set: (productId: string, priceInclVat: number) =>
        api.put<OnlinePriceItem>(`/online-prices/${productId}`, {
            price_incl_vat: priceInclVat,
        }),
    clear: (productId: string) =>
        api.delete<OnlinePriceItem>(`/online-prices/${productId}`),
}
